import { ReactNode } from "react";
import { Select, MenuItem } from '@mui/material';
import { SelectProps } from '@mui/material/Select';
import { MenuItemProps } from '@mui/material/MenuItem';

const menuItemStyle = {
	"&.Mui-selected:focus": {
		background: "var(--active-background)",
		fontWeight: "bold",
		color: "var(--dark-green-text-color)",
	},
	"&.Mui-selected": {
		background: "var(--active-background)",
		fontWeight: "bold",
		color: "var(--dark-green-text-color)",
	},
};

interface IMySelect extends SelectProps {
	children?: ReactNode;
	props?: SelectProps;
}

export function MySelect({
	children = null,
	...props
}: IMySelect) {
	return <Select
		displayEmpty
		color="success"
		sx={{ background: "#fff" }}
		{ ...props }
	>
		{ children }
	</Select>;
}

interface IMyMenuItem extends MenuItemProps {
	children?: ReactNode;
	props?: MenuItemProps;
}

export function MyMenuItem({
	children = null,
	...props
}: IMyMenuItem) {
	return <MenuItem sx={menuItemStyle} { ...props }>
		{ children }
	</MenuItem>;
}
